/**
 *
 * MobileMenu
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 26-Oct-2022
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import { AppBar, Toolbar, ListItemText, Grid, Button, Typography } from '@mui/material';
import PortalModal from 'Components/PortalModal';
import { routes } from '../../utils/routeNames';
import formattedMessage from '../../languageModule';
import style from './MobileMenu.scss';
import { logoutUser } from '../../utils/utils';

const MobileMenu = (props) => {
	const intl = useIntl();
	let navigate = useNavigate();

	const [open, setOpen] = useState(false);
	const [openSubmenu, setOpenSubmenu] = useState({
		0: false,
	});
	const [activeSubRoute, setActiveSubRoute] = useState(props.path);

	const handlerOpenMenu = () => {
		setOpen((prevState) => !prevState);
	};

	const handlerOpenSubmenu = (index) => {
		if (index !== undefined) {
			setOpenSubmenu({
				[index]: !openSubmenu[index],
			});
		} else {
			setOpenSubmenu({
				0: false,
			});
		}
	};

	const handleSetSubRoute = (route) => {
		setActiveSubRoute(route);
	};

	useEffect(() => {
		props.setActiveRoute(props.path);
	}, [props.path]);

	const [logout, setLogout] = useState(false);

	const Logout = () => (
		<PortalModal
			className={style.container}
			title={formattedMessage.logout}
			subtitle={formattedMessage.titolo}
			hasOutcome
			outcome='warning'
			open={logout}
			buttons={[
				{
					variant: 'outlined',
					onClick: () => {
						setLogout(false);
					},
					contentText: formattedMessage.annulla,
				},
				{
					variant: 'contained',
					onClick: () => {
						logoutUser()
							.then(() => {
								window.sessionStorage.clear();
								window.location.replace('/');
							})
							.catch((error) => {
								console.error(error);
							});
					},
					contentText: formattedMessage.conferma,
				},
			]}
		/>
	);

	if (props.path.toLowerCase() === 'startenrollment') {
		return '';
	}

	return (
		<>
			<AppBar
				position='static'
				className={`${style.appBarMobile} ${open ? style.isOpen : ''} ${!props.logged ? style.loginPage : ''}`}>
				<Toolbar>
					<Grid className={style.logo}>
						{/* TODO: FIX DYNAMIC LOGO */}
						<img src={props.logged ? props.logoLight : props.logoDark} alt={`logo ${props.brand}`} />
					</Grid>
					{props.logged ? (
						<>
							{open ? (
								<Grid className={style.container}>
									<Grid className={style.listContent}>
										<Grid className={style.menuList}>
											{routes
												.filter(({ routeName }) => props.permittedRoutes.includes(routeName))
												.map((element, index) => (
													<Grid
														key={`route-${index}`}
														className={`
														${style.menuItem}
														${openSubmenu[index] ? style.openSubmenu : ''}
													`}>
														<ListItemText
															key={`route-list-item-${index}`}
															className={`${style.listItem} ${props.activeRoute === element.route ? style.active : ''}`}
															primary={intl.formatMessage(element.label)}
															onClick={() => {
																element.route === ''
																	? (props.handleSetRoute(element.route, element.route),
																	  handlerOpenMenu(),
																	  handleSetSubRoute(''))
																	: null; // only home route
																handlerOpenSubmenu(index);
															}}
														/>
														{element.subRoutes.length > 0 ? (
															<Grid key={`subroute-${index}`} className={style.menuDropdown}>
																{element.subRoutes.map((elem, index) => (
																	<Typography
																		key={`subroute-item-${index}`}
																		variant='body1'
																		className={`${style.subItem} ${
																			activeSubRoute === elem.route && elem.route !== '' ? style.active : ''
																		}`}
																		onClick={() => {
																			props.handleSetRoute(elem.route, element.route);
																			handleSetSubRoute(elem.route);
																			handlerOpenMenu();
																		}}>
																		{intl.formatMessage(elem.label)}
																	</Typography>
																))}
															</Grid>
														) : null}
													</Grid>
												))}
										</Grid>
									</Grid>
									<Grid className={style.actionContent}>
										<Button
											className={`${style.button} ${props.activeRoute === 'account' ? style.active : ''}`}
											color='secondary'
											onClick={() => {
												navigate('/account');
												props.setActiveRoute('account');
												handlerOpenMenu();
											}}>
											<i className='nexi-icons-user' />
											<Typography className={`${style.label} ${style.user}`}>
												<FormattedMessage {...formattedMessage.profile} />
											</Typography>
										</Button>
										<Button
											className={style.button}
											color='secondary'
											onClick={() => {
												setLogout(true);
												handlerOpenSubmenu();
											}}>
											<Typography className={`${style.label} ${style.exit}`}>
												<FormattedMessage {...formattedMessage.logout} />
											</Typography>
											<i className='nexi-icons-exit' />
										</Button>
									</Grid>
								</Grid>
							) : null}
							<Grid
								className={style.burgerIcon}
								onClick={() => {
									handlerOpenMenu();
									openSubmenu ? handlerOpenSubmenu() : null;
								}}>
								{open ? <i className='nexi-icons-close' /> : <i className='nexi-icons-menu' />}
							</Grid>
						</>
					) : null}
				</Toolbar>
			</AppBar>
			<Logout />
		</>
	);
};

MobileMenu.propTypes = {
	// Add here some propTypes
	// and set a minimal description i.e.
	/** Description of prop "baz". */
	path: PropTypes.string,
	brand: PropTypes.string,
	logo: PropTypes.object,
	logged: PropTypes.bool.isRequired,
	handleSetRoute: PropTypes.func,
	logoLight: PropTypes.string,
	logoDark: PropTypes.string,
	activeRoute: PropTypes.string,
	setActiveRoute: PropTypes.func,
	permittedRoutes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

MobileMenu.defaultProps = {
	// Add here some default propTypes values
	path: '/',
	brand: '',
	handleSetRoute: () => {},
	setActiveRoute: () => {},
	permittedRoutes: ['Home'],
};

export default MobileMenu;
